import { IconMail, IconPhone } from "@tabler/icons-react";
import AnimalSelector from "./animal_selector";

function OrganizationGrid({ users }) {
  return (
    <ul className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
      {users?.map((user) => (
        <li
          key={user.email}
          className="col-span-1 flex flex-col divide-y divide-gray-200 rounded-lg bg-white text-center shadow-sm dark:divide-white/10 dark:bg-gray-800/50 dark:shadow-none dark:outline dark:-outline-offset-1 dark:outline-white/10"
        >
          <div className="flex flex-1 flex-col p-3">
            {user.imageUrl ? (
              <img
                alt=""
                src={user.imageUrl}
                className="mx-auto inline-block size-32 rounded-full outline -outline-offset-1 outline-black/5 dark:outline-white/10"
              />
            ) : (
              <span className="mx-auto inline-flex size-32 items-center justify-center rounded-full bg-gray-500 outline -outline-offset-1 outline-black/5 dark:bg-gray-800 dark:outline-white/10">
                <span className="text-3xl font-medium text-white">
                  {user.firstName[0]} {user.lastName[0]}
                </span>
              </span>
            )}
            <h3 className="mt-6 text-md font-medium text-gray-900 dark:text-white">
              {user.firstName} {user.lastName}
            </h3>
            <dl className="mt-1 flex grow flex-col justify-between">
              <dt className="sr-only">Role</dt>
              <dd className="mt-3">
                <span className="inline-flex items-center rounded-full bg-green-50 px-2 py-1 text-xs font-medium text-green-700 inset-ring inset-ring-green-600/20 dark:bg-green-500/10 dark:text-green-500 dark:inset-ring-green-500/10">
                  {user.title}
                </span>
              </dd>
            </dl>
          </div>
          <AnimalSelector animals={user.animals} />
          <div>
            <div className="-mt-px flex divide-x divide-gray-200 dark:divide-white/10">
              <div className="flex w-0 flex-1">
                <a
                  href={`mailto:${user.email}`}
                  className="relative -mr-px inline-flex w-0 flex-1 items-center justify-center gap-x-3 rounded-bl-lg border border-transparent py-4 text-sm font-semibold text-gray-900 dark:text-white"
                >
                  <IconMail
                    aria-hidden="true"
                    className="size-5 text-gray-400 dark:text-gray-500"
                  />
                  Email
                </a>
              </div>
              <div className="-ml-px flex w-0 flex-1">
                <a
                  href={`tel:${user.phone}`}
                  className="relative inline-flex w-0 flex-1 items-center justify-center gap-x-3 rounded-br-lg border border-transparent py-4 text-sm font-semibold text-gray-900 dark:text-white"
                >
                  <IconPhone
                    aria-hidden="true"
                    className="size-5 text-gray-400 dark:text-gray-500"
                  />
                  Call
                </a>
              </div>
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}

export default OrganizationGrid;
